import { useEffect } from 'react';

// utils
import getIndexOfSelector from './helpers';

const useURLRouting = (currentSelection, data, viewById, setFilters) => {
  useEffect(() => {
    let updatedSelectedIndex;
    if (currentSelection.nameShort && viewById) {
      updatedSelectedIndex = getIndexOfSelector(viewById, data, 'nameShort');
    }
    if (currentSelection.carrierName && viewById) {
      updatedSelectedIndex = getIndexOfSelector(viewById, data, 'carrierName');
    }
    updatedSelectedIndex > -1 &&
      setFilters({
        name: 'selectedIndex',
        value: updatedSelectedIndex,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewById]);
};

export default useURLRouting;
